import { render } from "./ServiceWrapper.vue?vue&type=template&id=d97fedd2"
import script from "./ServiceWrapper.vue?vue&type=script&lang=js"
export * from "./ServiceWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__